// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"c0d54eee","137":"66ec5c6f","167":"7ac88c99","428":"6c5aa6c2","769":"e607155b","872":"9eb49577","921":"608164c3"}[chunkId] + ".chunk.js";
};